function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.882 511.882",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F6BB42"
    },
    points: "350.216,176.572 278.374,158.615 37.038,264.123 0,338.207 125.753,374.324 386.13,258.531  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCE54"
    },
    points: "350.216,176.572 107.756,284.345 125.753,374.324 386.13,258.531 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E8AA3D"
    },
    points: "107.756,284.345 37.038,264.123 0.015,338.207 125.753,374.324 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F6BB42"
    },
    points: "475.969,212.682 404.127,194.717 162.791,300.232 125.753,374.324 251.504,410.41  511.882,294.625 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCE54"
    },
    points: "475.969,212.682 233.508,320.431 251.504,410.41 511.882,294.625 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E8AA3D"
    },
    points: "233.508,320.431 162.791,300.232 125.753,374.324 251.504,410.41 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F6BB42"
    },
    points: "396.316,119.429 324.488,101.473 103.867,198.435 66.843,272.519 192.596,308.621  432.245,201.379 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCE54"
    },
    points: "396.316,119.429 174.6,218.641 192.596,308.621 432.245,201.379 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E8AA3D"
    },
    points: "174.6,218.641 103.867,198.435 66.843,272.519 192.596,308.621 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldIcon);
export default __webpack_public_path__ + "static/media/gold-icon.081948b683f69694be9f44e8fd153b4c.svg";
export { ForwardRef as ReactComponent };